<template>
    <dx-check-box :value="checkbox" text="Текущие записи" @value-changed="onValueChange" />
    <ai-grid-edit-wrapper
        :meta="metaVdog"
        :args="argsVdog"
        ref="vdogGridRef"
        :action="getInstance"
        @grid-edit-wrapper-mounted="onGridEditWrapperMounted"
    />
    <ai-grid-edit-wrapper
        :meta="metaPril"
        :args="argsPril"
        ref="prilGridRef"
        to-remove-toolbar-items-names="['choice', 'copy', 'edit', 'addSibling', 'addChild', 'delete']"
    />
</template>

<script setup>
import { DxCheckBox } from 'devextreme-vue/check-box';
import { ref } from 'vue';
import { setActiveViewInfo, setViewData } from '@/layouts/main-layout/main-layout-data';
import { setTabReadyToSaveValue } from '@/layouts/main-layout/components/navigation-bars-data';

const onGridEditWrapperMounted = async () => {
    gridInstance.value = {
        refresh: setDataSource,
        userData: vdogGridRef.value.setUserDataFromCacheOrApi,
        userSettings: vdogGridRef.value.fetchAndSetUserSettings,
    };
    setActiveViewInfo(gridInstance.value);

    await setViewData();

    setTabReadyToSaveValue(true);
    vdogGridRef.value.ref.gridInstance.on('focusedRowChanged', getPrilData);
};

const gridInstance = ref();
let setDataSource;

const getInstance = inst => {
    setDataSource = inst.setDataSource;
};

const checkbox = ref(true);
const vdogGridRef = ref();
const prilGridRef = ref();

const metaVdog = {
    keyExpr: 'kod_vdog',
    title: 'Виды договоров',
    columns: [
        {
            name: 'name_obj_upr',
            caption: 'name_obj_upr',
            dataField: 'name_obj_upr1',
            allowEditing: true,
            width: 350,
            index: -2,
            visible: false,
        },
        {
            name: 'kod_podrs',
            caption: 'Подразделение',
            dataField: 'kod_podrs',
            allowEditing: true,
            calculateFilterExpression: (filterValue, selectedFilterOperation, target) => {
                return ['kod_podrs', 'contains', filterValue[0]];
            },
            editor: {
                type: 'ai-popup',
                text: 'name_obj_upr1',
            },
            component: {
                path: 'views/nsi/vid-dog-pril/vdog-podr-lookup.vue',
                id: 'kodp',
                text: 'name_parent_ext',
                saveButtonVisible: false,
                meta: {
                    toRemoveToolbarItemsNames: "['choice', 'copy', 'edit', 'addSibling', 'addChild', 'delete', 'save']",
                    keyExpr: 'kodp',
                    valueExpr: 'name_parent_ext',
                    columns: [
                        {
                            name: 'kodp',
                            caption: 'kodp',
                            dataField: 'kodp',
                            allowEditing: false,
                            width: 250,
                            index: 1,
                            visible: false,
                        },
                        {
                            name: 'name',
                            caption: 'Наименование подразделения',
                            dataField: 'name',
                            allowEditing: false,
                            width: 250,
                            index: 2,
                            visible: true,
                        },
                        {
                            name: 'name_parent_ext',
                            caption: 'name_parent_ext',
                            dataField: 'name_parent_ext',
                            allowEditing: false,
                            width: 250,
                            index: 3,
                            visible: false,
                        },
                        {
                            name: 'kod_parent',
                            caption: 'kod_parent',
                            dataField: 'kod_parent',
                            allowEditing: false,
                            width: 250,
                            index: 4,
                            visible: false,
                        },
                    ],
                    api: {
                        select: 'nsi./nsi/vdog-org-lookup/select/get',
                        save: 'nsi./nsi/vdog-org-lookup/save/set',
                    },
                    viewId: 'vdog-podr-lookup',
                    parentIdExpr: 'kod_parent',
                },
            },
            width: 250,
            index: 2,
            visible: true,
            fixed: true,
        },
        {
            name: 'name',
            caption: 'Группа потребителей',
            dataField: 'name',
            allowEditing: true,
            width: 200,
            index: -4,
            visible: true,
            fixed: true,
        },
        {
            name: 'kod_vdog',
            caption: 'kod_vdog',
            dataField: 'kod_vdog',
            allowEditing: true,
            width: 200,
            index: 12,
            visible: false,
        },
        {
            name: 'kod_vdoc',
            caption: 'Вид документа',
            dataField: 'kod_vdoc',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'name_doc',
            },
            component: {
                name: 'ks-vdoc-lookup',
                id: 'kod_vdoc',
                text: 'name',
            },
            width: 200,
            index: 3,
            visible: true,
        },
        {
            name: 'name_doc',
            caption: 'name_doc',
            dataField: 'name_doc',
            allowEditing: true,
            width: 200,
            index: -3,
            visible: false,
        },
        {
            name: 'sqrp',
            caption: 'Файл шаблона',
            dataField: 'sqrp',
            allowEditing: true,
            width: 200,
            index: 5,
            visible: true,
        },
        {
            name: 'day_energy',
            caption: 'Срок в днях до корректировки договорных значений энергии',
            dataField: 'day_energy',
            allowEditing: true,
            width: 200,
            index: 7,
            visible: true,
        },
        {
            name: 'day_power',
            caption: 'Срок в днях до корректировки договорных значений мощности',
            dataField: 'day_power',
            allowEditing: true,
            width: 200,
            index: 8,
            visible: true,
        },
        {
            name: 'tep_el',
            caption: 'tep_el',
            dataField: 'tep_el',
            allowEditing: true,
            width: 200,
            index: -8,
            visible: false,
        },
        {
            name: 'name_tep_el',
            caption: 'Тепло/Электричество',
            dataField: 'name_tep_el',
            allowEditing: false,
            width: 200,
            index: 9,
            visible: true,
        },
        {
            name: 'public_suite',
            caption: 'public_suite',
            dataField: 'public_suite',
            allowEditing: true,
            width: 200,
            index: -9,
            visible: false,
        },
        {
            name: 'kod_tipdog',
            caption: 'Тип договора',
            dataField: 'kod_tipdog',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'name_tipdog',
            },
            component: {
                name: 'tipdog-lookup-view',
                id: 'kod_tipdog',
                text: 'name',
            },
            width: 200,
            index: 10,
            visible: true,
        },
        {
            name: 'name_tipdog',
            caption: 'name_tipdog',
            dataField: 'name_tipdog',
            allowEditing: true,
            width: 200,
            index: -10,
            visible: false,
        },
        {
            name: 'forma_dog',
            caption: 'Форма договора',
            dataField: 'forma_dog',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'name_forma_dog',
            },
            component: {
                name: 'vdog-forma-lookup',
                id: 'forma_dog',
                text: 'name',
            },
            width: 200,
            index: 11,
            visible: true,
        },
        {
            name: 'name_forma_dog',
            caption: 'name_forma_dog',
            dataField: 'name_forma_dog',
            allowEditing: true,
            width: 200,
            index: -11,
            visible: false,
        },
        {
            name: 'byt',
            caption: 'byt',
            dataField: 'byt',
            allowEditing: true,
            width: 200,
            index: -6,
            visible: false,
        },
        {
            name: 'name_byt',
            caption: 'Частный сектор',
            dataField: 'name_byt',
            allowEditing: true,
            width: 200,
            index: 6,
            visible: true,
        },
        {
            name: 'kod_vivod',
            caption: 'kod_vivod',
            dataField: 'kod_vivod',
            allowEditing: true,
            width: 200,
            index: -12,
            visible: false,
        },
        {
            name: 'payer_kind',
            caption: 'payer_kind',
            dataField: 'payer_kind',
            allowEditing: true,
            width: 200,
            index: -13,
            visible: false,
        },
        {
            name: 'pr_arx',
            caption: 'Статус',
            dataField: 'pr_arx',
            allowEditing: true,
            editor: {
                type: 'ai-drop-down',
                text: 'status',
            },
            component: {
                name: 'vdog-status-lookup',
                id: 'pr_arx',
                text: 'status',
            },
            width: 200,
            index: 14,
            visible: true,
        },
        {
            name: 'status',
            caption: 'status',
            dataField: 'status',
            allowEditing: true,
            width: 200,
            index: 13,
            visible: false,
        },
        {
            name: 'kod_tipdog2',
            caption: 'kod_tipdog2',
            dataField: 'kod_tipdog2',
            allowEditing: true,
            width: 200,
            index: -15,
            visible: false,
        },
        {
            name: 'filesize',
            caption: 'filesize',
            dataField: 'filesize',
            allowEditing: true,
            width: 200,
            index: -16,
            visible: false,
        },
        {
            name: 'pr_ndog_auto',
            caption: 'pr_ndog_auto',
            dataField: 'pr_ndog_auto',
            allowEditing: true,
            width: 200,
            index: -17,
            visible: false,
        },
    ],
    api: {
        select: 'core./core/ksvdog-view-select/get',
        save: 'core./core/ksvdog-view-save/set',
    },
    viewId: 'ksvdog-view',
};

const argsVdog = {
    select: {
        select_args: {
            archive: Number(false),
        },
    },
};

const metaPril = {
    title: 'Приложения',
    toRemoveToolbarItemsNames: "['choice', 'copy', 'edit', 'addSibling', 'addChild', 'delete', 'save']",
    rights: {
        INS: false,
        DEL: false,
        UPD: true,
    },
    selectionMode: 'single',
    columns: [
        {
            name: 'kod_namepril',
            caption: 'kod_namepril',
            dataField: 'kod_namepril',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 10,
            index: 1,
            visible: false,
        },
        {
            name: 'pril_check',
            caption: ' ',
            dataField: 'pril_check',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 22,
            width: 50,
            visible: true,
            dataType: 'boolean',
        },
        {
            name: 'name_pril',
            caption: 'Наименование приложения',
            dataField: 'name_pril',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            index: 2,
            visible: true,
        },
        {
            name: 'kod_vdog',
            caption: 'kod_vdog',
            dataField: 'kod_vdog',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 10,
            index: 3,
            visible: false,
        },
        {
            name: 'kodpk_namepril',
            caption: 'kodpk_namepril',
            dataField: 'kodpk_namepril',
            allowEditing: true,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 10,
            index: 4,
            visible: false,
        },
        {
            name: 'prim',
            caption: 'Описание приложения',
            dataField: 'prim',
            allowEditing: false,
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 500,
            index: 5,
            visible: true,
        },
        {
            name: 'pr_arx',
            caption: 'Архивное',
            dataField: 'pr_arx',
            allowEditing: false,
            dataType: 'boolean',
            editor: {
                type: 'default',
                text: '',
            },
            component: {
                name: '',
                id: '',
                text: '',
            },
            width: 150,
            index: 6,
            visible: true,
        },
    ],
    api: {
        select: 'core./core/vdognamepril-view-select/get',
        save: 'core./core/vdognamepril-view-save/set',
    },
    keyExpr: 'kod_namepril',
    viewId: 'vdognamepril-view',
};

const argsPril = {
    select_args: {
        kod_vdog: '',
        ntep_el: '',
    },
};

const getPrilData = async e => {
    console.log(e);
    if (e.row === undefined) return;

    if (argsPril.select_args.kod_vdog !== e.row.data.kod_vdog) {
        argsPril.select_args.kod_vdog = e.row.data.kod_vdog;
        argsPril.select_args.ntep_el = e.row.data.tep_el;
        await prilGridRef.value.ref.setDataSource(false, argsPril);
    }
};

const onValueChange = async e => {
    console.log(e.value);
    checkbox.value = e.value;
    argsVdog.select.select_args.archive = Number(!e.value);

    await vdogGridRef.value.ref.setDataSource(false);
};
</script>

<script>
export default {
    name: 'vid-dog-pril',
};
</script>

<style scoped></style>
